import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  TextField,
  Typography
} from '@mui/material';

const vitalFields = [
  { key: 'bp', label: 'BP' },
  { key: 'temp', label: 'Temp' },
  { key: 'hr', label: 'HR' },
  { key: 'rr', label: 'RR' },
  { key: 'wt', label: 'WT (lb)' },
  { key: 'ht', label: 'HT (ft)' },
  { key: 'bmi', label: 'BMI' }
];

const EncounterVitals = ({ vitals }) => (
  <Box sx={{ mb: 2 }}>
    <Typography
      sx={{
        mb: 1.5,
        color: '#424242',
        fontSize: 13,
        fontWeight: 500
      }}
    >
      Vital Signs
    </Typography>

    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
        gap: 1.2
      }}
    >
      {vitalFields.map(field => (
        <TextField
          key={field.key}
          fullWidth
          size="small"
          label={field.label}
          value={vitals?.[field.key] || ''}
          InputProps={{
            readOnly: true
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: 34,
              fontSize: 13
            },

            '& .MuiInputLabel-root': {
              fontSize: 12
            }
          }}
        />
      ))}
    </Box>
  </Box>
);

EncounterVitals.propTypes = {
  vitals: PropTypes.shape({
    bp: PropTypes.string,
    temp: PropTypes.string,
    hr: PropTypes.string,
    rr: PropTypes.string,
    wt: PropTypes.string,
    ht: PropTypes.string,
    bmi: PropTypes.string
  })
};

EncounterVitals.defaultProps = {
  vitals: {}
};

export default EncounterVitals;